
import React, { Component } from 'react';
import { SHr, SIcon,  SText, STheme, SView } from 'servisofts-component2';
import Logo from '../../../Assets/svg/registro/logo.svg'
export default class SectionHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <SView col={"xs-12"} center backgroundColor={STheme.color.barColor}>
                <SView col={"xs-12"} height={100} center>
                    <Logo height={"100%"} name={"logowhite"} fill={STheme.color.text} />
                </SView>
                <SHr height={20} />
                <SView col={"xs-12"} height={40} row center>
                    <SText fontSize={20} color={STheme.color.text} >Iniciar Sesión</SText>
                    {/* <SView col={"xs-6"} height card>
                        <PButtom2 outline={true} onPress={() => {
                            SNavigation.navigate("/registro")
                        }}>Registro</PButtom2>
                    </SView> */}

                </SView>
            </SView>
        );
    }
}
